import GIF_URL from "../../assets/images/pepsi.gif";
import FirebaseService from "../../core/services/firebase.service";
import CenteredPopup from "../CenteredPopup/CenteredPopup";
import FirebaseKey from "../FirebaseKey/FirebaseKey";
const REDIRECT_URL = "https://kazandirio.go.link/i4UxA";

const GIF_BY_VARIANT: Record<"journey" | "game", string> = {
  journey: GIF_URL,
  game: GIF_URL,
};

interface LoginAlertPopupProps {
  isOpen: boolean;
  onClose: () => void;
  variant: "journey" | "game";
  onLoginClick: () => void;
}

const LoginAlertPopup = ({
  isOpen,
  onClose,
  variant,
  onLoginClick,
}: LoginAlertPopupProps) => {
  const gifUrl = GIF_BY_VARIANT[variant];

  return (
    <CenteredPopup isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col p-2">
        <div className="flex items-center justify-between m-2 mb-4">
          <h2 className="text-base font-medium text-black">
            {variant === "journey" ? <FirebaseKey firebaseKey={FirebaseService.journey_alert_title} /> : <FirebaseKey firebaseKey={FirebaseService.games_alert_title} />}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="p-2 -m-2 rounded-full hover:bg-black/5 transition-colors"
            aria-label="Close"
          >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#807E7D" fill-opacity="0.12" />
              <path d="M12.2289 12.2291L19.7713 19.7716M19.7712 12.2291L12.2287 19.7716" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

          </button>
        </div>

        <div className="w-full rounded-[32px] overflow-hidden bg-[rgba(128,126,125,0.15)] aspect-square mb-2 flex items-center justify-center">
          <img
            src={gifUrl}
            alt={variant === "journey" ? "Journey preview" : "Game preview"}
            className="w-full h-full object-cover"
          />
        </div>

        <button
          type="button"
          onClick={() => {
            window.location.href = REDIRECT_URL;
            // onClose();
            // onLoginClick();
          }}
          className="w-full p-4 rounded-full bg-[#0088FF] text-white font-medium transition-colors hover:opacity-90 active:opacity-80"
        >
          <FirebaseKey firebaseKey={variant === "journey" ? FirebaseService.journey_alert_button : FirebaseService.games_alert_button} />
        </button>
      </div>
    </CenteredPopup>
  );
};

export default LoginAlertPopup;
